module.exports = __webpack_public_path__ + "static/media/others.5a728be3.jpg";